import DialogBridge from 'bridges/dialogBridge';
import useBeautyFilterBanubaStore from 'stores/beautyFilter/beautyFilterBanubaStore';
import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';

/**
 * Android 버전 273 미만인 경우 업데이트 다이얼로그를 표시하고 false를 반환합니다.
 */
export const checkPermit = () => {
  const version = BResource.getVersionInt();
  if (Device.name === 'android' && version < 273) {
    const store = 'Google Play';
    const url = 'http://play.google.com/store/apps/details?id=vixr.bermuda';
    const desc = brsc.update_popup_desc.replace('$param', store);
    void DialogBridge.open({
      title: brsc.update_popup_title,
      description: desc,
      confirmText: brsc.confirm,
    }).then((confirmed) => {
      if (confirmed) Device.openURL(url);
    });

    return false;
  } else {
    return true;
  }
};

// useBeautyFilterSlider
/**
 * [-1, 1] => True / [0, 1] => False
 */
export const isSymmetricRange = (range: number[]) => range[0] === -1 && range[1] === 1;

/**
 * sliderValue (0 ~ 1000) -> normalizedValue (0 ~ 100) -> banubaValue (min ~ max)
 */
export const sliderValueToBanubaValue = (sliderValue: number, range: number[]) => {
  const normalizedValue = Math.round(sliderValue / 10);
  const banubaValue = isSymmetricRange(range) ? normalizedValue / 50 - 1 : (normalizedValue / 100) * (range[1] - range[0]);
  return Math.round(banubaValue * 100) / 100;
};

/**
 * banubaValue (min ~ max) -> normalizedValue (0 ~ 100) -> sliderValue (0 ~ 1000)
 */
export const banubaValueToSliderValue = (banubaValue: number, range: number[]) => {
  const normalizedValue = isSymmetricRange(range) ? (banubaValue + 1) * 50 : ((banubaValue - range[0]) / (range[1] - range[0])) * 100;
  const sliderValue = Math.round(normalizedValue * 10);
  return sliderValue;
};

/**
 * sliderValue (0 ~ 1000) -> presetValue (0 ~ 100)
 */
export const sliderValueToPresetValue = (sliderValue: number) => {
  return Math.round(sliderValue / 10);
};

/**
 * presetValue (0 ~ 100) -> sliderValue (0 ~ 1000)
 */
export const presetValueToSliderValue = (presetValue: number) => {
  return Math.round(presetValue * 10);
};

// ba
export const baShowBeautyFilterModal = () => {
  const baObj = {
    fbUid: myinfo.fbUid,
    gender: myinfo.gender,
    swipeCnt: myinfo.swipeCnt,
    device: Device.name,
    country: myinfo.country,
    purchaseCount: MyDataManager.getPurchaseCount(),
  };
  ba('show-beauty-filter-modal', undefined, baObj);
  BLog.log('baShowBeautyFilterModal', baObj);
};

export const baHideBeautyFilterModal = () => {
  const isUsingPreset = useBeautyFilterBanubaStore.getState().isUsingPreset();
  const isUsingBeauty = useBeautyFilterBanubaStore.getState().isUsingBeauty();
  const isUsingMakeup = useBeautyFilterBanubaStore.getState().isUsingMakeup();
  const isUsingMood = useBeautyFilterStore.getState().mood.isUsingMood(); // Clear에서 다른 무드로 바꿔 쓰는 중
  const isUsingSticker = useBeautyFilterStore.getState().sticker.isUsingSticker();
  // GPU passthrough 기기는 선택 상태가 남아 있어도 네이티브가 적용을 무시하므로 실제 적용 중이 아니다
  const gpuPassthrough = useBeautyFilterBanubaStore.getState().gpuPassthrough;
  const isUsing = !gpuPassthrough && (isUsingPreset || isUsingBeauty || isUsingMakeup || isUsingMood || isUsingSticker);
  const changedCount = useBeautyFilterStore.getState().baData.changedCount;
  let isApplied = '';
  if (isUsing) {
    isApplied = 'true'; // 뷰티, 메이크업, 무드, 스티커 중 하나 이상 적용 중일 때
  } else if (changedCount > 0) {
    isApplied = 'reset'; // 현재 세션에서 뷰티 필터를 1회 이상 사용하면서, 아무 뷰티 필터도 적용하지 않고 있을 때 (무드까지 제거)
  } else {
    isApplied = 'false'; // 아무 뷰티 필터도 적용하지 않고 있을 때 (무드는 Clear)
  }

  // 이 세션에서 실제로 조작한 항목. 선택만 하고 값을 안 건드린 항목은 담기지 않는다
  // (색 선택 시 주입되는 coverage 0.5, highlighter 진입 시 자동 선택되는 Champagne,
  //  이전 세션에서 persist 된 prefab 값이 사용으로 새지 않게).
  const usedItems = useBeautyFilterStore.getState().baData.usedItems;
  const items = Object.entries(usedItems).map(([id, item]) => ({ id, category: item.category, key: item.key, subKey: item.subKey, value: item.value }));

  const baObj = {
    fbUid: myinfo.fbUid,
    gender: myinfo.gender,
    swipeCnt: myinfo.swipeCnt,
    device: Device.name,
    country: myinfo.country,
    purchaseCount: MyDataManager.getPurchaseCount(),
    host: window.location.hostname, // ba 인덱스에 환경 필드가 없어 dev 트래픽을 사후에 거르려면 필요하다
    itemCount: items.length,
    items: items,
    isApplied: isApplied,
    isUsingPreset: isUsingPreset,
    isUsingBeauty: isUsingBeauty,
    isUsingMakeup: isUsingMakeup,
    isUsingMood: isUsingMood,
    isUsingSticker: isUsingSticker,
    changedCount: changedCount,
    gpuPassthrough: gpuPassthrough,
  };
  ba('hide-beauty-filter-modal', undefined, baObj);
  BLog.log('baHideBeautyFilterModal', baObj);
};

// Banuba 사용 불가 판정(초기화 타임아웃/실패/애셋 실패) 크라우드 보고.
// banuba-local-block과 같은 필드 구성으로 모델별 집계 → remote config banuba_blacklist 갱신 판단에 사용.
export const baBanubaUnavailable = (reason: 'timeout' | 'init_failed' | 'asset_failed') => {
  // 안드로이드 ANR 디버깅 용도라 안드로이드만 보고한다. iOS 네이티브는 실패 사유(detail)를 넘기지 않아 건수 외 정보가 없다
  if (Device.name !== 'android') return;
  // 안드로이드 웹뷰 UA의 "; <모델명> Build/" 패턴에서 추출 (예: SM-A536N). 없으면 빈 값
  const model = navigator.userAgent.match(/;\s*([^;)]+)\s+Build\//)?.[1] ?? '';
  // 발화 시점(inited 후 +10s)엔 myinfo가 항상 있지만, 초기화 순서가 바뀌어도 콜백이 안 터지게 방어
  const info = typeof myinfo !== 'undefined' ? myinfo : undefined;
  const baObj = {
    fbUid: info?.fbUid ?? '',
    country: info?.country ?? '',
    device: Device.name,
    model: model,
    osVersion: getUserAgentInfo().osVersion,
    reason: reason,
    // 네이티브가 OnBanubaInitializeFailed(reason)로 알려준 세부 실패 사유
    // (blacklist/crash_guard/gpu/low_score/score_fetch_failed/no_score_old_os/sdk_exception/not_prepared 등, 구앱은 unspecified)
    detail: (window as { gBanubaInitFailReason?: string }).gBanubaInitFailReason ?? '',
    host: window.location.hostname, // dev 트래픽 사후 필터용
  };
  ba('banuba-unavailable', undefined, baObj);
  BLog.log('baBanubaUnavailable', baObj);
};
